import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.thumbnail}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2.5 py-1 rounded-full">
            {article.category === 'guide' ? '平台指南' : article.category === 'news' ? '最新动态' : '帮助中心'}
          </span>
          <span className="text-xs text-foreground-400">{article.publishDate}</span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
      </div>
    </Link>
  );
}